import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { SkinImage } from '@app/dev/terminal/components/skinImage';
import Config from '@app/dev/config/main';

import './style.scss';

const MediaSlider = () => {
  let sliderContent;
  if (Config.main.temporaryBannerExperation && moment()
    .isBefore(moment(Config.main.temporaryBannerExperation))) {
    sliderContent = [
      <Link
        to={Config.main.temporaryBannerPath}
        key={Config.main.temporaryBanner}
        className="media-item"
      >
        <SkinImage
          path={`homeMediaSlider/media-slide-${Config.main.temporaryBanner}.${Config.main.temporaryBannerFileType || 'jpg'}`}
        />
      </Link>,
    ];
  } else {
    sliderContent = Config.main.homeMediaSlides.map((slide) => (
      <Link to={slide.path} key={slide.type} className="media-item">
        <SkinImage
          fileType={slide.fileType}
          path={`homeMediaSlider/media-slide-${slide.type}.${slide.fileType || 'jpg'}`}
        />
      </Link>
    ));
  }

  const Arrow = ({
    direction,
    style,
    onClick
  }) => (
    <i style={style} className={`global-icon icon-slim-arrow-${direction}`} onClick={onClick} />
  );

  return (
    <div className="home-media-slider">
      <Slider
        dots={sliderContent.length > 1}
        accessibility={false}
        arrows={sliderContent.length > 1}
        nextArrow={<Arrow direction="right" />}
        prevArrow={<Arrow direction="left" />}
        autoplay
        infinite={sliderContent.length > 1}
        draggable={Config.main.homeMediaSlides.length > 1}
        autoplaySpeed={8000}
        dragging={false}
        slidesToShow={1}
        slidesToScroll={1}
      >
        {sliderContent}
      </Slider>
    </div>
  );
};

export default MediaSlider;
